module.exports = __webpack_public_path__ + "static/icon00323b6cc9b864e82dcd391416eeb4195fe2.png";